import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import "./map-popup.scss";
import { LocalStore } from "../../../utils/LocalStore";

import { Tabs } from "antd";
export default class Note extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listColor: [],
      listColorPK: [],
    };

    this.listColorRanhGioi = [ "#3f48cc", "#ff7f26", '#FA3411', '#00FFC5', '#000000', '#828282'];

    this.listTenRanhGioi = [
      "Ranh giới dự án quy hoạch",
      "Ranh giới kiến trúc",
      "Lòng đường",
      "Lề đường",
      "Tim đường",
      "Đường sắt",
    ];
  }

  componentDidMount() {
    this.getDataTable();
    this.getDataTablePK();
  }

  async getDataTable() {
    let res = await AxiosGetSecretApi("/api/bang-mau/all");
    if (res && Array.isArray(res)) {
      this.setState({
        listColor: res,
      });
    }
  }

  async getDataTablePK() {
    let res = await AxiosGetSecretApi("/api/bang-mau/all-pk");
    if (res && Array.isArray(res)) {
      this.setState({
        listColorPK: res,
      });
    }
  }

  isLogged = () => {
    let token = LocalStore.getInstance().read("loginSession");
    if (token) {
      return true;
    }
    return false;
  };

  render() {
    return (
      <div className="popup-note">
        <div className="title">
          Chú giải
          <i
            className="fas fa-times icon-close"
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        <div className="gr-content-ranh-gioi">
          <div className="sub-title">Phân loại dữ liệu dạng line</div>
          <div className="table-title">
            <div className="text-title left">Ký hiệu</div>
            <div className="text-title right">Tên</div>
          </div>

          {this.listColorRanhGioi.map((e, i) => (
            <div className="table-title">
              
              <div className="left">
                {i === 5 &&  <img src="/duongsat.jpg" style={{width: "120px" }}  alt=""></img>}
                {i === 4 &&  <img src="/timduong.jpg" style={{width: "120px" }}  alt=""></img>}
                { i < 4 && <div style = {{
                  borderTop: `2px dashed`,
                  marginTop: "9px",
                  borderColor: `${e}`
                }}> </div>}
              </div>
              <div
                className="right"
                style={{
                  fontSize: "12px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                {this.listTenRanhGioi[i]}
              </div>
            </div>
          ))}
        </div>
        <div className="gr-content">
          <div className="sub-title">Phân loại chức năng sử dụng đất</div>
          <div className="content">
            Dựa theo quy định trong Phụ lục của Thông tư số 12/2016/TT-BXD ngày
            29/06/2016 của Bộ trưởng Bộ Xây dựng
          </div>
        </div>

        {/* {this.isLogged() ? ( */}
        <>
          {this.props.type ? (
            <>
              {this.props.type === "tab1" ? (
                <>
                  <div
                    className
                    style={{ display: "flex", padding: "5px 10px 0 10px" }}
                  >
                    <div
                      className="text-title"
                      style={{ minWidth: "47px", marginLeft: "0" }}
                    >
                      Màu sắc
                    </div>
                    <div
                      className="text-title"
                      style={{ textAlign: "center", width: "100%" }}
                    >
                      Tên loại đất
                    </div>
                  </div>
                  <div className="gr-table" style={{ maxHeight: "200px" }}>
                    {this.state.listColor.map((e, i) => (
                      <div
                        className
                        style={{ display: "flex", marginTop: "5px" }}
                      >
                        <div
                          className="color-box left"
                          style={{ backgroundColor: `#${e.Color}` }}
                        >
                          {" "}
                        </div>
                        <div className="text right">{e.Mota}</div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className
                    style={{ display: "flex", padding: "5px 10px 0 10px" }}
                  >
                    <div
                      className="text-title"
                      style={{ minWidth: "47px", marginLeft: "0" }}
                    >
                      Màu sắc
                    </div>
                    <div
                      className="text-title"
                      style={{ textAlign: "center", width: "100%" }}
                    >
                      Tên loại đất
                    </div>
                  </div>
                  <div className="gr-table" style={{ maxHeight: "200px" }}>
                    {this.state.listColorPK.map((e, i) => (
                      <div
                        className
                        style={{ display: "flex", marginTop: "5px" }}
                      >
                        <div
                          className="color-box left"
                          style={{ backgroundColor: `#${e.Color}` }}
                        >
                          {" "}
                        </div>
                        <div className="text right">{e.TenloaiPolygon}</div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </>
          ) : (
            <Tabs>
              <Tabs.TabPane key="1" tab="Quy hoạch chi tiết + chung">
                <div
                  className
                  style={{ display: "flex", padding: "5px 10px 0 10px" }}
                >
                  <div
                    className="text-title"
                    style={{ minWidth: "47px", marginLeft: "0" }}
                  >
                    Màu sắc
                  </div>
                  <div
                    className="text-title"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    Tên loại đất
                  </div>
                </div>
                <div className="gr-table">
                  {this.state.listColor.map((e, i) => (
                    <div
                      className
                      style={{ display: "flex", marginTop: "5px" }}
                    >
                      <div
                        className="color-box left"
                        style={{ backgroundColor: `#${e.Color}` }}
                      >
                        {" "}
                      </div>
                      <div className="text right">{e.Mota}</div>
                    </div>
                  ))}
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane key="3" tab="Quy hoạch phân khu">
                <div
                  className
                  style={{ display: "flex", padding: "5px 10px 0 10px" }}
                >
                  <div
                    className="text-title"
                    style={{ minWidth: "47px", marginLeft: "0" }}
                  >
                    Màu sắc
                  </div>
                  <div
                    className="text-title"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    Tên loại đất
                  </div>
                </div>
                <div className="gr-table">
                  {this.state.listColorPK.map((e, i) => (
                    <div
                      className
                      style={{ display: "flex", marginTop: "5px" }}
                    >
                      <div
                        className="color-box left"
                        style={{ backgroundColor: `#${e.Color}` }}
                      >
                        {" "}
                      </div>
                      <div className="text right">{e.TenloaiPolygon}</div>
                    </div>
                  ))}
                </div>
              </Tabs.TabPane>
            </Tabs>
          )}
        </>
        {/* ) : (
          <>
            <div
              className
              style={{ display: "flex", padding: "5px 10px 0 10px" }}
            >
              <div
                className="text-title"
                style={{ minWidth: "47px", marginLeft: "0" }}
              >
                Màu sắc
              </div>
              <div
                className="text-title"
                style={{ textAlign: "center", width: "100%" }}
              >
                Tên loại đất
              </div>
            </div>
            <div className="gr-table" style={{ maxHeight: "200px" }}>
              {this.state.listColor.map((e, i) => (
                <div className style={{ display: "flex", marginTop: "5px" }}>
                  <div
                    className="color-box left"
                    style={{ backgroundColor: `#${e.Color}` }}
                  >
                    {" "}
                  </div>
                  <div className="text right">{e.Mota}</div>
                </div>
              ))}
            </div>
          </>
        )} */}
      </div>
    );
  }
}
